import React, { useEffect, useRef, useState } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import CustomCursor from './customCursor';
export default function VideoCursorStripWrapper(props) {
    var fields = props.fields, children = props.children, isDisabled = props.isDisabled;
    //console.log("isDisabled: ",isDisabled);
    var containerRef = useRef(null);
    var cursorLinkRef = useRef(null);
    var cursorIsInsideBannerRef = useRef(false);
    var isDisabledRef = useRef(isDisabled);
    var _a = useState(false), modal = _a[0], setModal = _a[1];
    var _b = useState(false), cursorIsInsideBanner = _b[0], setCursorIsInsideBanner = _b[1];
    var toggle = function () {
        setModal(false);
    };
    var cursorXY = useRef({ x: 0, y: 0 });
    //const [cursorIsVisible, setCursorIsVisible] = useState(false);   
    //const [cursorContent, setCursorCursorContent] = useState("");
    useEffect(function () {
        cursorIsInsideBannerRef.current = cursorIsInsideBanner;
    }, [cursorIsInsideBanner]);
    useEffect(function () {
        //if (isDisabled) return;
        var moveCursor = function (e) {
            cursorXY.current.x = e.clientX;
            cursorXY.current.y = e.clientY;
            //setCursorIsVisible(true);
        };
        window.addEventListener('mousemove', moveCursor);
        return function () {
            window.removeEventListener('mousemove', moveCursor);
        };
    }, []);
    var onMouseEnterStrip = function () {
        if (fields.cursorContent && fields.cursorContent.length > 0) {
            //setCursorCursorContent(fields.cursorContent);
            //setCursorBackgroundColor(fields.cursorBackgroundColor ? fields.cursorBackgroundColor : '');
            //setCursorTextColor(fields.cursorTextColor ? fields.cursorTextColor : '');
            setCursorIsInsideBanner(true);
        }
    };
    var onMouseLeaveStrip = function () {
        if (fields.cursorContent && fields.cursorContent.length > 0) {
            //setCursorCursorContent("");
            setCursorIsInsideBanner(false);
        }
    };
    var clickStripByBtn = function (e) {
        if (!fields.youTubeID)
            return;
        // open video modal
        setModal(true);
    };
    var clickStrip = function (e) {
        // isDisabled has the old value, so use the ref var  
        if (isDisabledRef.current || !(fields.cursorContent || "").length)
            return; // || (!isTouch && !cursorIsInsideBannerRef.current)
        if (fields.cursorAction == "link") {
            cursorLinkRef.current && cursorLinkRef.current.click();
            return;
        }
        if (!fields.youTubeID)
            return;
        //var targetEl = (props.targetElRef && props.targetElRef.current) || containerRef.current;
        //console.log("click strip: ", e.target == targetEl);
        setModal(true);
    };
    var triggerOnScroll = function () {
        if (isDisabled)
            return;
        var targetEl = (props.targetElRef && props.targetElRef.current) || containerRef.current;
        //console.log("on scroll matches :hover", targetEl && targetEl.matches(':hover'));
        if (targetEl) {
            var rect = targetEl.getBoundingClientRect();
            if (cursorXY.current.x < rect.left ||
                cursorXY.current.x > rect.right ||
                cursorXY.current.y < rect.top ||
                cursorXY.current.y > rect.bottom) {
                // onMouseLeaveStrip();
            }
            else {
                //  onMouseEnterStrip();
            }
        }
    };
    var resetMouseEvents = function () {
        return;
        var targetEl = (props.targetElRef && props.targetElRef.current) || containerRef.current;
        console.log("reset mouse events", targetEl);
        if (targetEl) {
            //targetEl.removeEventListener('mouseover', onMouseEnterStrip);
            targetEl.removeEventListener('mouseenter', onMouseEnterStrip);
            // targetEl.removeEventListener('mouseout', onMouseLeaveStrip);
            targetEl.removeEventListener('mouseleave', onMouseLeaveStrip);
            targetEl.removeEventListener('click', clickStrip);
            targetEl.removeEventListener('customClick', clickStripByBtn);
            if (!isDisabled) {
                //targetEl.addEventListener('mouseover', onMouseEnterStrip);
                targetEl.addEventListener('mouseenter', onMouseEnterStrip);
                // targetEl.addEventListener('mouseout', onMouseLeaveStrip);
                targetEl.addEventListener('mouseleave', onMouseLeaveStrip);
                targetEl.addEventListener('click', clickStrip);
                targetEl.addEventListener('customClick', clickStripByBtn);
            }
        }
    };
    useEffect(function () {
        isDisabledRef.current = isDisabled;
        resetMouseEvents();
    }, [isDisabled]);
    useEffect(function () {
        //if (isDisabled) return;
        var targetEl = (props.targetElRef && props.targetElRef.current) || containerRef.current;
        //console.log("targetElRef changed - add mouseenter event", targetEl);
        // console.log("video cursor wrapper - init - ", containerRef, props.targetElRef);
        if (targetEl) {
            //targetEl.addEventListener('mouseover', onMouseEnterStrip);
            targetEl.addEventListener('mouseenter', onMouseEnterStrip);
            //targetEl.addEventListener('mouseout', onMouseLeaveStrip);
            targetEl.addEventListener('mouseleave', onMouseLeaveStrip);
            targetEl.addEventListener('click', clickStrip);
            targetEl.addEventListener('customClick', clickStripByBtn);
            // Manually dispatch the event if the cursor is already over the element
            setTimeout(function () {
                if (targetEl.matches(':hover')) {
                    var event_1 = new MouseEvent('mouseenter', {
                        bubbles: true,
                        cancelable: true,
                        view: window
                    });
                    targetEl.dispatchEvent(event_1);
                }
            });
        }
        window.addEventListener('scroll', triggerOnScroll);
        setTimeout(triggerOnScroll, 50);
        return function () {
            if (targetEl) {
                //targetEl.removeEventListener('mouseover', onMouseEnterStrip);
                targetEl.removeEventListener('mouseenter', onMouseEnterStrip);
                //targetEl.removeEventListener('mouseout', onMouseLeaveStrip);
                targetEl.removeEventListener('mouseleave', onMouseLeaveStrip);
                targetEl.removeEventListener('click', clickStrip);
                targetEl.removeEventListener('customClick', clickStripByBtn);
            }
            window.removeEventListener('scroll', triggerOnScroll);
        };
    }, [props.targetElRef]);
    var isTouch = ('ontouchstart' in window || navigator && navigator.maxTouchPoints);
    return (React.createElement("div", { ref: containerRef, style: (!isTouch && !isDisabled && (fields.cursorContent || "").length) && cursorIsInsideBanner ? { cursor: 'none' } : {} },
        (!isTouch && !isDisabled && (fields.cursorContent || "").length) && React.createElement(CustomCursor, { isVisible: cursorIsInsideBanner, cursorBackgroundColor: fields.cursorBackgroundColor, cursorContent: fields.cursorContent, cursorTextColor: fields.cursorTextColor }) || null,
        children,
        fields.youTubeID && React.createElement(Modal, { isOpen: modal, toggle: toggle, fullscreen: true },
            React.createElement(ModalHeader, { toggle: toggle }),
            React.createElement(ModalBody, null,
                React.createElement("iframe", { id: "bannerVideoIFrame" + fields.youTubeID, className: "vimeo", src: "https://www.youtube.com/embed/" + fields.youTubeID + "?enablejsapi=1&muted=1&rel=0&amp;showinfo=0", allowFullScreen: true, width: "100%", height: "100%" }))) || null,
        fields.cursorAction == "link" && fields.link && React.createElement("a", { ref: cursorLinkRef, "aria-hidden": "true", style: { "display": "none" }, onClick: props.handleStripLinkClick || null, href: fields.link }, fields.cursorContent)));
}
